import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Receipt, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ReceiptButton({ path }) {
  const [loading, setLoading] = useState(false);
  if (!path) return null;

  const open = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/files/${path}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank");
    } catch (e) {
      toast.error("Impossibile aprire lo scontrino");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={open}
      data-testid="view-receipt-btn"
      className="rounded-md"
    >
      {loading ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Receipt className="mr-1.5 h-4 w-4" />}
      Scontrino
    </Button>
  );
}
